import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    ctaLabel: 'Delete the invitation',
    description:
      'By deleting the invite, they will no longer be able to register and join the {companyName}\'s Shine account. However, you will be able to invite them again via the "Invite a new member" button.',
    success: 'Invitation successfully deleted',
    title: "You are about to remove {firstName} {lastName}'s invite",
  },
  fr: {
    cancel: 'Annuler',
    ctaLabel: 'Supprimer l’invitation',
    description:
      'Si vous supprimez son invitation, {firstName} {lastName} ne pourra ni finaliser son inscription ni rejoindre le compte Shine de {companyName}. Vous pourrez cependant renouveler son invitation via le bouton "Inviter un nouveau membre".',
    success: 'Invitation supprimée avec succès',
    title:
      'Vous êtes sur le point de supprimer l‘invitation de {firstName} {lastName}',
  },
} as const);

export default locales;
